export default __webpack_public_path__ + "static/media/hht2_ep20_timeline_05_blank.c2e96495.png";